import { apiV2 } from '../lib/baseAxios';

const ragQuestionAnswer = async (question: string) => {
  return apiV2.get(`/rag/search?question=${question}`);
};

export default ragQuestionAnswer;
